import { render } from "./settingsApiAccess.vue?vue&type=template&id=5a0bae1e"
import script from "./settingsApiAccess.vue?vue&type=script&lang=js"
export * from "./settingsApiAccess.vue?vue&type=script&lang=js"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__